import { TrackEvent } from "../../../core/internal/event/UserEvent"
import { DecisionReason, InAppMessage } from "../../../core/internal/model/model"

export class InAppMessageTrigger {
  constructor(readonly inAppMessage: InAppMessage, readonly reason: DecisionReason, readonly event: TrackEvent) {}

  /**
   * @override
   */
  toString(): string {
    return `InAppMessageTrigger(inAppMessage=${this.inAppMessage.toString()}, reason=${this.reason}, insertId=${
      this.event.insertId
    }, timestamp=${this.event.timestamp}, event=${this.event.event.key})`
  }
}
